
import Qrcode from 'vux/src/components/qrcode/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
name: 'cardSpecial',
components: {
Qrcode,Datetime
},
data () {
return {
popUp:false,
dateStatus:false,
size:250,
days:'',
qrcode:'',
endDate:'',
coupon:'',
info:{},
}
},
created(){
this.cardSpecial();
this.setDate();
},
mounted(){

},
activated(){

},
methods:{
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear() + 1,
month: nowDate.getMonth() + 1,
day: nowDate.getDate() - 1,
}
this.endDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
},
showDate(e){
this.dateStatus = true;
},
dateChange(e){
this.endDate = e;
},
cardSpecial(){
this.$api.cardSpecial({}).then((res)=>{
if(res){
this.info = res.data;
}
})
},
submit(){
if(this.coupon > 40){
this.$func.showToast('优惠券最多赠送40张');
return false;
}
if(!this.days && !this.endDate){
this.$func.showToast('请输入会员时长或会员到期时间');
return false;
}
this.$api.subCardSpecial({days:this.days,coupon:this.coupon,endDate:this.endDate}).then((res)=>{
if(res){
this.qrcode = res.data;
console.log('qrcode',res.data);
this.popUp = true;
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/cardSpecial.vue